import { useMemo } from "react"
import { useTranslation } from "react-i18next"

import { home as enHome } from "./locales/en-US/home"
import { home as esHome } from "./locales/es-ES/home"
import { home as ptHome } from "./locales/pt-BR/home"

export type HomeCopy = typeof ptHome

const LOCALE_MAP: Record<string, HomeCopy> = {
  "pt-BR": ptHome as HomeCopy,
  "en-US": enHome as unknown as HomeCopy,
  "es-ES": esHome as unknown as HomeCopy,
}

export function useLocaleCopy(): HomeCopy {
  const { i18n } = useTranslation()
  const lang = i18n.resolvedLanguage ?? i18n.language ?? "pt-BR"

  return useMemo(() => {
    if (LOCALE_MAP[lang]) {return LOCALE_MAP[lang]}
    const base = lang.split("-")[0]
    if (base === "pt") {return LOCALE_MAP["pt-BR"]}
    if (base === "en") {return LOCALE_MAP["en-US"]}
    if (base === "es") {return LOCALE_MAP["es-ES"]}
    return LOCALE_MAP["pt-BR"]
  }, [lang])
}
